/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as ApplicationDataStoreActions from './application-data-store.actions';

import { Application } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'ApplicationDataStore';

/* State interface */
export interface ApplicationState {
  isLoading?: boolean;
  applications?: Application[];
  activeApplication?: object;
  newApplication?: object;
}

/* Initial values */
export const initialState: ApplicationState = {
  isLoading: null,
  applications: null,
  activeApplication: {},
  newApplication: {},
};

export const reducer = createReducer(
  initialState,
  on(
    ApplicationDataStoreActions.UpdateActiveApplicationSuccessful,
    (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  ),

  on(
    ApplicationDataStoreActions.UpdateActiveApplicationFailure,
    (state, action) => {
      return {
        ...state,
      };
    },
  ),

  on(ApplicationDataStoreActions.GetApplications, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ApplicationDataStoreActions.GetApplicationsSuccessful,
    (state, action) => ({
      ...state,
      applications: action.payload.applications,
      isLoading: false,
    }),
  ),

  on(ApplicationDataStoreActions.GetApplicationsFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(ApplicationDataStoreActions.GetApplicationById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ApplicationDataStoreActions.GetApplicationByIdSuccessful,
    (state, action) => ({
      ...state,
      /* TODO: replace item by id from data array */
      isLoading: false,
    }),
  ),

  on(
    ApplicationDataStoreActions.GetApplicationByIdFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(ApplicationDataStoreActions.CreateApplication, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ApplicationDataStoreActions.CreateApplicationSuccessful,
    (state, action) => ({
      ...state,
      applications: [...(state.applications ?? []), action.payload.application],
      isLoading: false,
    }),
  ),

  on(ApplicationDataStoreActions.CreateApplicationFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(ApplicationDataStoreActions.UpdateApplication, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ApplicationDataStoreActions.UpdateApplicationSuccessful,
    (state, action) => ({
      ...state,
      applications: updateEntityInArray<Application>(
        action.payload.id,
        action.payload.data,
        state.applications ?? [],
      ),
      isLoading: false,
    }),
  ),

  on(ApplicationDataStoreActions.UpdateApplicationFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(ApplicationDataStoreActions.DeleteApplication, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ApplicationDataStoreActions.DeleteApplicationSuccessful,
    (state, action) => ({
      ...state,
      applications:
        state.applications?.filter((item) => action.payload.id !== item.id) ??
        [],
      isLoading: false,
    }),
  ),

  on(ApplicationDataStoreActions.DeleteApplicationFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(ApplicationDataStoreActions.ResetState, () => initialState),
);
